export const customTypeExtensionConfig = {
  /** Container property for custom extensions. I.e. myArr.{ContainerProperty}.{ExtensionMethod}() */
  containerPropertyName: "extensions",
};
